import { LastPromptPreferencesPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const LastPromptPreferencesPersistenceProvider =
  createStaticContextProvider(
    LastPromptPreferencesPersistenceContext,
    lazyValue(() =>
      import("./last-prompt-preferences-persistence").then(
        (module) => module.lastPromptPreferencesPersistence,
      ),
    ),
  );
